﻿import React from 'react'
import { Alert, Badge, Dialog, IconButton, Snackbar } from '@mui/material'
import AssignmentIcon from '@mui/icons-material/Assignment'
import { usePMJournal } from './usePMJournal'
import PMJournalList from './PMJournalList'
import PMJournalEditor from './PMJournalEditor'

const PMJournal = () => {
    const j = usePMJournal()

    return (
        <>
            <IconButton size="large" color="inherit" onClick={() => { j.setViewMode('list'); j.setDialogOpen(true) }}>
                <Badge>
                    <AssignmentIcon />
                </Badge>
            </IconButton>

            <Snackbar
                open={!!j.snackbar}
                autoHideDuration={4000}
                onClose={() => j.setSnackbar(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert onClose={() => j.setSnackbar(null)} severity={j.snackbar?.severity} sx={{ width: '100%' }}>
                    {j.snackbar?.message}
                </Alert>
            </Snackbar>

            <Dialog open={j.dialogOpen} onClose={() => j.setDialogOpen(false)} maxWidth="lg" fullWidth scroll="body">
                {j.viewMode === 'list' && (
                    <PMJournalList
                        journals={j.journals}
                        listLoading={j.listLoading}
                        listFrom={j.listFrom}
                        setListFrom={j.setListFrom}
                        listTo={j.listTo}
                        setListTo={j.setListTo}
                        listFilter={j.listFilter}
                        setListFilter={j.setListFilter}
                        errorMsg={j.errorMsg}
                        openNewJournal={j.openNewJournal}
                        openExistingJournal={j.openExistingJournal}
                        projectName={j.projectName}
                    />
                )}
                {j.viewMode === 'editor' && (
                    <PMJournalEditor
                        currentHeader={j.currentHeader}
                        isNew={j.isNew}
                        journalType={j.journalType}
                        setJournalType={j.setJournalType}
                        selectedProjectId={j.selectedProjectId}
                        setSelectedProjectId={j.setSelectedProjectId}
                        journalDate={j.journalDate}
                        setJournalDate={j.setJournalDate}
                        lines={j.lines}
                        setLines={j.setLines}
                        saving={j.saving}
                        releasing={j.releasing}
                        deleting={j.deleting}
                        reopening={j.reopening}
                        isBusy={j.isBusy}
                        errorMsg={j.errorMsg}
                        permitFrom={j.permitFrom}
                        permitTo={j.permitTo}
                        isWithinYeWindow={j.isWithinYeWindow}
                        yeWindowFrom={j.yeWindowFrom}
                        yeWindowTo={j.yeWindowTo}
                        saveJournal={j.saveJournal}
                        releaseJournal={j.releaseJournal}
                        reopenJournal={j.reopenJournal}
                        deleteJournal={j.deleteJournal}
                        addLine={j.addLine}
                        updateLine={j.updateLine}
                        removeLine={j.removeLine}
                        getFilteredActivities={j.getFilteredActivities}
                        getFilteredProjects={j.getFilteredProjects}
                        projectName={j.projectName}
                        setViewMode={j.setViewMode}
                        projects={j.projects}
                    />
                )}
            </Dialog>
        </>
    )
}

export default PMJournal
